// extracted by mini-css-extract-plugin
module.exports = {"theme":"#304e72"};